import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";
import { TYPE_LABELS } from "@/types/media";

interface NewsPanelProps {
  items: NewsItem[];
}

export default function NewsPanel({ items }: NewsPanelProps) {
  const [lead, ...rest] = items;
  if (!lead) return null;

  return (
    <section className="rounded-lg border border-background-200 bg-background-100 p-5">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-background-50">
            <i className="ri-newspaper-line text-sm"></i>
          </span>
          <h2 className="font-heading text-lg font-bold text-foreground-950">
            最新影视资讯
          </h2>
        </div>
        <Link
          to="/news"
          className="flex items-center gap-1 text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          全部
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-base"></i>
          </span>
        </Link>
      </div>

      <Link to={`/news/${lead.id}`} className="group block">
        <div className="h-44 w-full overflow-hidden rounded-md bg-background-200 md:h-52">
          <img
            src={lead.cover}
            alt={lead.title}
            title={`${lead.title} 资讯配图`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
          <span>{lead.date}</span>
          <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
            {TYPE_LABELS[lead.category]}
          </span>
        </div>
        <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {lead.title}
        </h3>
        <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {lead.summary}
        </p>
      </Link>

      <div className="mt-2">
        {rest.slice(0, 6).map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="group flex items-start gap-3 border-t border-background-200 py-3"
          >
            <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
              <i className="ri-article-line text-sm"></i>
            </span>
            <div className="min-w-0">
              <h4 className="line-clamp-1 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                {item.title}
              </h4>
              <span className="mt-0.5 block text-xs text-foreground-500">
                {item.date}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}